import React from 'react';

//CORE COMPONENTS
import { ThemeProvider, styled } from '../../../components-core/packages/components-core/dist/theme-provider/index';
import {
    Container,
    ContainerWrap,
    ContainerPadding,
    ContainerGutter,
    ContainerHorizontalAlignment,
    ContainerVerticalAlignment
} from '../../../components-core/packages/components-core/dist/container/index';
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { BreakpointWrapper } from '../../../components-core/packages/components-core/dist/breakpoint-wrapper';


//CUSTOM COMPONENTS
import { TopContainer } from '../../helpers/ComponentHelpers';
import HorizontalCarList from './inner-components/horizontal-car-list/HorizontalCarList';
import PriceTable from './inner-components/price-table/PriceTable';
import PriceCard from './inner-components/price-card/PriceCard';


class PriceList extends React.Component {

    constructor() {
        super();
        this.state = {
            selectedCar: 'Caddy'
        }
    }

    renderPriceTables() {
        const renderedObjects = [];
        if (this.props.priceList[this.state.selectedCar]) {
            for (let [key, value] of Object.entries(this.props.priceList[this.state.selectedCar])) {
                console.log(value)
                renderedObjects.push(
                    <PriceTable
                        generalName={this.state.selectedCar + ' ' + key}
                        priceList={value}
                    />
                )
            }
        }

        return renderedObjects;
    }


    render() {

        return (
            <IntegratorRoot>
                <ThemeProvider>
                    <TopContainer>
                        <Container stretchContent={true} wrap={ContainerWrap.always} gutter={ContainerGutter.dynamic0200}>
                            <HorizontalCarList />
                            <BreakpointWrapper max={Breakpoints.b560}>
                                <PriceCard priceList={this.props.priceList} />
                            </BreakpointWrapper>
                            <BreakpointWrapper min={Breakpoints.b560}>
                                <Container wrap={ContainerWrap.always} gutter={ContainerGutter.dynamic0200}>
                                {this.renderPriceTables()}
                                </Container>
                            </BreakpointWrapper>
                        </Container>
                    </TopContainer>
                </ThemeProvider>
            </IntegratorRoot>
        )
    }
}

export default PriceList;